export function DashboardPageLayout({ children }) {
  return (
    <main className="max-w-[1300px] mx-auto px-10 py-16 sm:px-6 lg:flex-auto lg:px-10 lg:py-10">
      {children}
    </main>
  );
}
